require('./Orwell');
module.exports = 'ngOrwell';
